/**
 * @module modules/calendar-input-sk
 * @description <h2><code>calendar-input-sk</code></h2>
 *
 * Displays a text input for the date along with a button that pops up a dialog
 * allowing the user to select the date from a calendar-sk.
 *
 * @evt input - A CustomEvent<Date> with the new date.
 *
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CalendarInputSk", {
    enumerable: true,
    get: function() {
        return CalendarInputSk;
    }
});
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
const _live = require("lit/directives/live.js");
require("../../../elements-sk/modules/icons/date-range-icon-sk");
require("../calendar-sk");
const _calendarsk = require("../calendar-sk/calendar-sk");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
var _CalendarInputSk;
let CalendarInputSk = (_CalendarInputSk = class CalendarInputSk extends _lit.LitElement {
    createRenderRoot() {
        return this;
    }
    render() {
        return (0, _lit.html)`
      <label for="date-${this.uniqueId}">
        <input
          id="date-${this.uniqueId}"
          name="date-${this.uniqueId}"
          @input=${this.inputChangeHandler}
          type="text"
          pattern="[0-9]{4}-[0-9]{1,2}-[0-9]{1,2}"
          title="Date in YYYY-MM-DD format."
          placeholder="yyyy-mm-dd"
          .value="${(0, _live.live)(`${this._displayDate.getFullYear()}-${this._displayDate.getMonth() + 1}-${this._displayDate.getDate()}`)}" />
        <span class="invalid" aria-live="polite" title="Date is invalid."> &cross; </span>
      </label>
      <button
        id="cal-button-${this.uniqueId}"
        class="action"
        @click=${this.openHandler}
        title="Open calendar dialog to choose the date.">
        <date-range-icon-sk></date-range-icon-sk>
      </button>
      <dialog @cancel=${this.dialogCancelHandler}>
        <calendar-sk
          @change=${this.calendarChangeHandler}
          .displayDate=${this.displayDate}></calendar-sk>
        <button @click=${this.dialogCancelHandler}>Cancel</button>
      </dialog>
    `;
    }
    inputChangeHandler(e) {
        // We don't change event from the input element to be confused with the
        // 'change' event that CalendarInputSk will produce.
        e.stopPropagation();
        e.preventDefault();
        const inputElement = e.target;
        if (inputElement.validity.patternMismatch) {
            return;
        }
        // Since we have checked validity above we can parse the values with
        // confidence here.
        const dateString = inputElement.value;
        const parts = dateString.split('-');
        try {
            this.displayDate = new Date(+parts[0], +parts[1] - 1, +parts[2]);
        } catch (_error) {
            return;
        }
        this.sendEvent();
    }
    openHandler() {
        this.dialog.showModal();
        this.dialog.addEventListener('keydown', this.keyboardForwarder);
    }
    sendEvent() {
        this.dispatchEvent(new CustomEvent('input', {
            detail: this.displayDate,
            bubbles: true
        }));
    }
    calendarChangeHandler(e) {
        this.displayDate = e.detail;
        this.sendEvent();
        this.dialog.close();
        this.dialog.removeEventListener('keydown', this.keyboardForwarder);
        this.input.focus();
    }
    dialogCancelHandler() {
        this.dialog.close();
        this.dialog.removeEventListener('keydown', this.keyboardForwarder);
    }
    /** The default date, if not set defaults to today. */ get displayDate() {
        return this._displayDate;
    }
    set displayDate(val) {
        this._displayDate = val;
    }
    /** @prop locale - The locale, used just for testing. */ get locale() {
        return this.calendar.locale;
    }
    set locale(val) {
        this.calendar.locale = val;
    }
    constructor(...args){
        super(...args);
        this.uniqueId = `${CalendarInputSk.nextUniqueId++}`;
        this._displayDate = new Date();
        this.keyboardForwarder = (e)=>this.calendar.keyboardHandler(e);
    }
}, (()=>{
    _CalendarInputSk.nextUniqueId = 0;
})(), _CalendarInputSk);
_ts_decorate([
    (0, _decorators.query)('dialog'),
    _ts_metadata("design:type", typeof HTMLDialogElement === "undefined" ? Object : HTMLDialogElement)
], CalendarInputSk.prototype, "dialog", void 0);
_ts_decorate([
    (0, _decorators.query)('calendar-sk'),
    _ts_metadata("design:type", typeof _calendarsk.CalendarSk === "undefined" ? Object : _calendarsk.CalendarSk)
], CalendarInputSk.prototype, "calendar", void 0);
_ts_decorate([
    (0, _decorators.query)('input'),
    _ts_metadata("design:type", typeof HTMLInputElement === "undefined" ? Object : HTMLInputElement)
], CalendarInputSk.prototype, "input", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", typeof Date === "undefined" ? Object : Date)
], CalendarInputSk.prototype, "_displayDate", void 0);
CalendarInputSk = _ts_decorate([
    (0, _decorators.customElement)('calendar-input-sk')
], CalendarInputSk);
